module.exports = __webpack_public_path__ + "img/about.9e3531d.jpg";